import { brandTitle, BrandTitle, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCreateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCreateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandCreateRequest) {
    JsonSchemaValidator.assert(RoomBrandCreateRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandTitle"],
      properties: {
        roomId,
        brandTitle
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCreateRequest {
  roomId: RoomId;
  brandTitle: BrandTitle;
}
